export default {
    data() {
        return {
            colors: {
                graphite: '#444444',
                primary: '#0063A6',
                secondary: '#00406A',
                white: '#FFFFFF'
            }
        }
    },
    methods: {
        calcColor(fontColor, fallback) {
            // return `${fontColor.hex}`
            if (!fontColor) return fallback || this.colors.graphite
            if (fontColor.rgb && fontColor.rgb.a && fontColor.rgb.a < 1) {
                // console.log(fontColor)
                const { r, g, b, a } = fontColor.rgb
                // return `${fontColor.hex}`
                return `rgba(${r},${g},${b},${a})`
            } else if (fontColor.hex) {
                return `${fontColor.hex}`
            }
            return fallback || this.colors.graphite
        },
        calcBGColor(bgColor, fallback) {
            if (!bgColor) return fallback || this.colors.white
            if (bgColor.rgb && bgColor.rgb.a && bgColor.rgb.a < 1) {
                // console.log(fontColor)
                const { r, g, b, a } = bgColor.rgb
                // return `${fontColor.hex}`
                return `rgba(${r},${g},${b},${a})`
            } else if (bgColor.hex) {
                return `${bgColor.hex}`
            }
            return fallback || this.colors.graphite
        }
    }
}
